import { useLingui } from '@lingui/react/macro';
import { getPlayerPositionLabel } from 'modules/teams/domain/constants/player-position-labels';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import React from 'react';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { TeamPlayerAvatar, TeamPlayerContainer } from './styles';

interface TeamCardPlayerProps {
  player: TeamPlayer;
  className?: string;
}

const TeamCardPlayer = (props: TeamCardPlayerProps) => {
  const { player, className } = props;
  const { t } = useLingui();
  const positionLabel = getPlayerPositionLabel(player.position);

  return (
    <TeamPlayerContainer className={className}>
      <TeamPlayerAvatar url={player.avatar || USER_DEFAULT_AVATAR} size={36} />
      <div className="player-info">
        <div className="player-name">
          {player.firstName}
          {'\u00A0'}
          {player.lastName}
        </div>
        <div className="player-position">
          #{player.number} {positionLabel ? t(positionLabel) : player.position}
        </div>
      </div>
    </TeamPlayerContainer>
  );
};

export default TeamCardPlayer;
